// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Common Client V2 imports
const CardGrid = require('client-v2/common/components/card-grid')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('DiscoverSection')

class DiscoverSection extends React.PureComponent {

  renderGrid() {
    return (
      tag(CardGrid, Object.assign({}, this.props, {
        className: bem.element('grid')
      }))
    )
  }

  renderHeader() {
    if (!this.props.isHeaderVisible) {
      return null
    }
    return (
      tag('div', {
        className: bem.element('header')
      },
        tag('div', {
          className: bem.element('heading')
        },
          `Discover your next favorite thing.`
        ),
        tag('div', {
          className: bem.element('subheading')
        },
          `
            Go deeper into new topics and explore any interest.
            Then share with others.
          `
        )
      )
    )
  }

  renderMoreButton() {
    if (!this.props.isMoreAvailable) {
      return null
    }
    return (
      tag('button', {
        className: bem.element('button'),
        onClick: this.props.onMoreClick
      },
        `Load more`
      )
    )
  }

  render() {
    return (
      tag('div', {
        className: bem.block()
      },
        this.renderHeader(),
        this.renderGrid(),
        this.renderMoreButton()
      )
    )
  }
}

DiscoverSection.propTypes = {
  // Flags
  isHeaderVisible: PropTypes.bool,
  isMoreAvailable: PropTypes.bool,
  // Callbacks
  onMoreClick: PropTypes.func
}

module.exports = DiscoverSection
